import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { WorkspaceService } from 'src/app/core/services/workspace.service';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
  selector: 'vcp-request-popup',
  templateUrl: './request-popup.component.html',
  styleUrls: ['./request-popup.component.scss'],
})
export class RequestPopupComponent {
  reason;
  btnLoader = false;
  constructor(
    public dialogRef: MatDialogRef<RequestPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly workspaceService: WorkspaceService,
    private us: UtilityService
  ) { }

  saveData() {
    switch (this.data.type) {
      case 'join': {
        const queryObj = {
          action: 'JOIN_WORKSPACE',
        };
        this.rejoinWorkspace(queryObj);
        break;
      }
      case 'rejoin': {
        const queryObj = {
          action: 'REJOIN_WORKSPACE',
        };
        this.rejoinWorkspace(queryObj);
        break;
      }
      case 'leave':
        this.leaveWorkspace();
        break;
    }
  }

  leaveWorkspace() {
    if (this.btnLoader) return;
    let data = {
      reason: this.reason,
      userId: this.us.getUserId(),
    };
    this.btnLoader = true;
    this.workspaceService
      .leaveWorkspaceRequest(data, this.data.workspace.workspaceId)
      .subscribe((res) => {
        this.btnLoader = false;
        if (res && res['code'] === 'success') {
          this.dialogRef.close(this.data);
        }
      });
  }


  rejoinWorkspace(queryObj) {
    if (this.btnLoader) return;
    let data = {
      reason: this.reason,
      userId: this.us.getUserId(),
      workspaceId: this.data.workspace.workspaceId,
      username: this.us.getUserName(),
      invitedBy: this.data.workspaceType && this.data.workspaceType === 'public'
        ? this.us.getUserId() : this.data.workspace.invitedBy,
    };
    const param = this.us.getObjToQueryParam(queryObj);
    this.btnLoader = true
    this.workspaceService
      .joinRequest(data, param)
      .subscribe((res) => {
        this.btnLoader = false;
        if (res && res['code'] === 'success') {
          this.dialogRef.close(this.data);
        }

      });
  }


  onNoClick(): void {
    this.dialogRef.close();
  }
}
